import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { BT } from '../models/models';
import { Api } from './api';

@Injectable()
export class BtsService {
  private endpoint: string = 'bts';

  constructor(private api: Api) {
  }

  public saveAllBts(bts: BT[]): Observable<any> {
    let saveBtRequests: Observable<any>[] = [];
    bts.forEach((bt: BT) => {
      saveBtRequests.push(this.api.put(`${this.endpoint}`, bt)
        .map(res => res.json()));
    });
    return Observable.forkJoin(saveBtRequests);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/bts.service.ts